import { Text } from "@medoma/components/Text/Text";
import { Trans } from "@lingui/react/macro";

export const GuideTemplateRakus = () => {
  return (
    <Trans>
      <Text element="p">Sveicināti!</Text>

      <Text element="p">
        Jūs saņemat slimnīcas līmeņa aprūpi savās mājās droši, profesionāli un
        ērti. Par Jums rūpējas ārsti un māsas, un slimnīca uzņemas pilnu
        atbildību par Jūsu veselības aprūpi mājas apstākļos. Mūsu komanda ir
        pieejama visu diennakti 24 stundas diennaktī, 7 dienas nedēļā.
      </Text>

      <Text element="p">
        Lai ārstēšanās noritētu veiksmīgi, svarīga ir arī Jūsu līdzdalība. Jūsu
        atbildība ir atsaukties, kad zvana ārsts vai māsa, lietot zāles tieši
        tā, kā norādīts, un regulāri veikt un iesniegt ārsta nozīmētos
        mērījumus. Tāpat lūdzam saudzīgi izturēties pret izsniegto inventāru un
        ārstēšanās laikā nelietot alkoholu vai citas apreibinošas vielas.
      </Text>

      <Text element="p">
        Ja pašsajūta pasliktinās, nekavējoties sazinieties ar &quot;Slimnīca
        mājās&quot; komandu. Ārsts vai māsa novērtēs Jūsu veselības stāvokli un,
        ja nepieciešams, organizēs ārstēšanās turpināšanu slimnīcā. Mēs esam
        šeit, lai nodrošinātu piemērotāko aprūpi jebkurā situācijā.
      </Text>

      <Text element="p">
        Ja rodas dzīvībai bīstama situācija, piemēram, pēkšņa elpas trūkuma
        saasināšanās, stipras sāpes krūtīs vai samaņas zudums, nekavējoties
        zvaniet 113.
      </Text>

      <Text element="p">
        Pēc ārstēšanās beigām Jūs saņemsiet pacientu aptauju Medoma lietotnē.
        Lūdzam to aizpildīt, jo Jūsu atsauksme palīdzēs mums uzlabot pakalpojuma
        kvalitāti un pacientu pieredzi nākotnē.
      </Text>

      <Text element="p">
        Paldies, ka uzticējāties &quot;Slimnīca mājās&quot; komandai. Mūsu
        mērķis ir, lai Jūs justos droši, aprūpēti un soli tuvāk pilnīgai
        atveseļošanai — tieši savās mājās.
      </Text>
    </Trans>
  );
};
